export {COMPONENT_NAME as TARIFF_COPY_SUMMARY_NAME} from './tariff-copy-summary/tariff-copy-summary.component'